import React from 'react';
import QCXFormStepWizard from '../../shared-components/form-step-wizard/QCXFormStepWizard';
import QCXSelectManyDespachantesTable from './QCXSelectManyDespachantesTable';

export default function QCXSelectManyDespachantesFinalFormTable({
  list = [],
  isConsult,
  title,
  filterProp,
  filterPropGetter,
  columns,
  handleSubmit,
  handleChange,
  controlComponentProps,
  ...restProps
}) {
  return (
    <QCXFormStepWizard
      onSubmit={handleSubmit}
      controlComponentProps={controlComponentProps}
      {...restProps}
    >
      {() => (
        <QCXSelectManyDespachantesTable
          title={title}
          columns={columns}
          filterProp={filterProp}
          selected={list}
          isConsult={isConsult}
          handleChange={handleChange}
        />
      )}
    </QCXFormStepWizard>
  );
}
